import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const ServerAPI = process.env.SERVER_API;
import { createContext, useState, useMemo, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { requestAPI } from 'utils/api';
import { UIContext } from './UIContext';
const GlobalDataContext = createContext({
    userDB: {}, setUserDB: () => null,
    userListDB: [], setUserListDB: () => null,
    userViewDB: {}, setUserViewDB: () => null,
    agencyUserListDB: [], setAgencyUserListDB: () => null,
    agencyUserViewDB: [], setAgencyUserViewDB: () => null,
    agencyListDB: [], setAgencyListDB: () => null,
    agencyViewDB: {}, setAgencyViewDB: () => null,
    classroomListDB: [], setClassroomListDB: () => null,
    classroomViewDB: {}, setClassroomViewDB: () => null,
    classroomMemberListDB: [], setClassroomMemberListDB: () => null,
    classroomMemberViewDB: {}, setClassroomMemberViewDB: () => null,
    certificateListDB: [], setCertificateListDB: () => null,
    courseListDB: [], setCourseListDB: () => null,
    courseViewDB: {}, setCourseViewDB: () => null,
    myClassroomListDB: [], setMyClassroomListDB: () => null,
    myClassroomViewDB: {}, setMyClassroomViewDB: () => null,
    selectAgencyDB: {}, setSelectAgencyDB: () => null,
    agencyDB: {}, setAgencyDB: () => null,
    surveyBankListDB: [], setSurveyBankListDB: () => null,
    surveyBankViewDB: {}, setSurveyBankViewDB: () => null,
    testBankListDB: [], setTestBankListDB: () => null,
    testBankViewDB: {}, setTestBankViewDB: () => null,
    lessonBankListDB: [], setLessonBankListDB: () => null,
    lessonBankViewDB: {}, setLessonBankViewDB: () => null,
    userClassInfoViewDB: {}, setUserClassInfoViewDB: () => null,
    userCertificateListDB: [], setUserCertificateListDB: () => null,
    userCertificateViewDB: {}, setUserCertificateViewDB: () => null,
    getDB: ({ db, params }) => { },
    wrapAPI: (method, path, data) => { },
    actionRecord: ({ path, type, action, result, title, data, etc }) => { },
    allowAccessGroup: (arr) => { },
    sidebarOpen: false, setSidebarOpen: () => null,
    /* eslint-enable @typescript-eslint/no-empty-function */
});
const GlobalDataProvider = ({ lng, 
//memberInfo, 
initInfo, children }) => {
    const { modal, notify } = useContext(UIContext);
    console.log('[GlobalDataProvider] Init ');
    const navigate = useNavigate();
    const location = useLocation();
    // 나의 정보
    const [userDB, setUserDB] = useState(initInfo.memberInfo);
    // 유저 목록, 유저 목록에서 선택한 유저 정보
    const [userListDB, setUserListDB] = useState([]);
    const [userViewDB, setUserViewDB] = useState({});
    // 에이전시 유저 목록
    const [agencyUserListDB, setAgencyUserListDB] = useState([]);
    const [agencyUserViewDB, setAgencyUserViewDB] = useState({});
    // 에이전시 유저 목록에서 선택한 유저 정보
    const [agencyListDB, setAgencyListDB] = useState(initInfo.agencyList);
    const [agencyViewDB, setAgencyViewDB] = useState({});
    const [classroomListDB, setClassroomListDB] = useState([]);
    const [classroomViewDB, setClassroomViewDB] = useState({});
    const [classroomMemberListDB, setClassroomMemberListDB] = useState([]);
    const [classroomMemberViewDB, setClassroomMemberViewDB] = useState({});
    const [certificateListDB, setCertificateListDB] = useState([]);
    const [courseListDB, setCourseListDB] = useState(initInfo.courseList);
    const [myClassroomListDB, setMyClassroomListDB] = useState([]);
    const [myClassroomViewDB, setMyClassroomViewDB] = useState({});
    const [selectAgencyDB, setSelectAgencyDB] = useState(initInfo.selectAgency);
    const [courseViewDB, setCourseViewDB] = useState({});
    const [agencyDB, setAgencyDB] = useState({});
    const [surveyBankListDB, setSurveyBankListDB] = useState([]);
    const [surveyBankViewDB, setSurveyBankViewDB] = useState({});
    const [testBankListDB, setTestBankListDB] = useState([]);
    const [testBankViewDB, setTestBankViewDB] = useState({});
    const [lessonBankListDB, setLessonBankListDB] = useState([]);
    const [lessonBankViewDB, setLessonBankViewDB] = useState({});
    const [userClassInfoViewDB, setUserClassInfoViewDB] = useState({});
    const [userCertificateListDB, setUserCertificateListDB] = useState([]);
    const [userCertificateViewDB, setUserCertificateViewDB] = useState({});
    const [sidebarOpen, setSidebarOpen] = useState(false);
    if (allowAccessGroup() !== 'PASS') {
        window.location.href = "/notaccessallowed";
        return (_jsx(_Fragment, {}));
    }
    const values = {
        userDB, setUserDB,
        userListDB, setUserListDB,
        userViewDB, setUserViewDB,
        agencyUserListDB, setAgencyUserListDB,
        agencyUserViewDB, setAgencyUserViewDB,
        agencyViewDB, setAgencyViewDB,
        agencyListDB, setAgencyListDB,
        classroomListDB, setClassroomListDB,
        classroomViewDB, setClassroomViewDB,
        classroomMemberListDB, setClassroomMemberListDB,
        classroomMemberViewDB, setClassroomMemberViewDB,
        certificateListDB, setCertificateListDB,
        courseListDB, setCourseListDB,
        courseViewDB, setCourseViewDB,
        myClassroomListDB, setMyClassroomListDB,
        myClassroomViewDB, setMyClassroomViewDB,
        selectAgencyDB, setSelectAgencyDB,
        agencyDB, setAgencyDB,
        surveyBankListDB, setSurveyBankListDB,
        surveyBankViewDB, setSurveyBankViewDB,
        testBankListDB, setTestBankListDB,
        testBankViewDB, setTestBankViewDB,
        lessonBankListDB, setLessonBankListDB,
        lessonBankViewDB, setLessonBankViewDB,
        userClassInfoViewDB, setUserClassInfoViewDB,
        userCertificateListDB, setUserCertificateListDB,
        userCertificateViewDB, setUserCertificateViewDB,
        getDB,
        allowAccessGroup,
        wrapAPI,
        actionRecord,
        sidebarOpen, setSidebarOpen
    };
    function userDBUpdate() {
        let url = location.pathname;
        if (userDB.tokenInfo === "Guest") {
            if (url === '/signin') {
                // 손님의 경우 로그인 페이지 접근
            }
            else {
                // 손님의 경우 다른 페이지 접근 시 로그인 페이지로 강제 이동
                switch (url) {
                    case '/logout':
                        navigate('/logout');
                        break;
                    default:
                        navigate('/signin');
                        break;
                }
            }
        }
        else {
            if (url === '/signin') {
                // 로그인된 유저는 로그인 페이지 접근 금지하며 기본 페이지로 강제 이동
                window.location.href = basicHome();
            }
            else {
                if (url === '/') {
                    window.location.href = basicHome();
                    //navigate('/signin');
                }
                else {
                    navigate(url);
                }
            }
        }
    }
    function allowAccessGroup() {
        /* SideLeftBar.tsx 수정필요 */
        const group = {
            '/': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
            '/401': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
            '/404': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
            '/users': ['SUPER', 'HQ'],
            '/home': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
            '/agencies': ['SUPER', 'HQ'],
            '/agencyusers': ['SUPER', 'HQ', 'AGENCY'],
            '/classroom': ['SUPER', 'HQ', 'AGENCY'],
            '/certificates': ['SUPER', 'HQ', 'AGENCY'],
            '/courses': ['SUPER', 'HQ'],
            '/sms': ['SUPER', 'HQ'],
            '/myclassrooms': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
            '/surveybank': ['SUPER', 'HQ'],
            '/survey': ['SUPER', 'HQ'],
            '/testbank': ['SUPER', 'HQ'],
            '/lessonbank': ['SUPER', 'HQ'],
            '/userhome': ['CAREGIVER'],
        };
        let url = location.pathname;
        let sw = null;
        if (group[url] === undefined)
            url = '/404';
        if (userDB.tokenInfo === 'Guest') {
            return 'PASS';
        }
        else {
            sw = group[url].find((item) => item === userDB.userInfo.role);
            if (sw === undefined)
                return 'FAIL';
            return 'PASS';
        }
    }
    ;
    function getDB({ db, params, update }) {
        return new Promise(async (resolve, reject) => {
            let store = values[db];
            let setStore = values[`set${db.charAt(0).toUpperCase() + db.slice(1)}`];
            let url = "";
            let res = null;
            let result = null;
            switch (db) {
                case 'userListDB':
                    url = `v1/users`;
                    break;
                case 'userViewDB':
                    url = `v1/users/${params.id}`;
                    break;
                case 'agencyUserListDB':
                    url = `v1/agencyusers/${params.id}`;
                    break;
                case 'agencyUserViewDB':
                    url = `v1/agencyuser/${params.id}`;
                    break;
                case 'agencyListDB':
                    url = `v1/agencies`;
                    break;
                case 'agencyViewDB':
                    url = `v1/agency/${params.id}`;
                    break;
                case 'classroomListDB':
                    url = `v1/classrooms/agencyid/${params.id}`;
                    break;
                case 'classroomViewDB':
                    url = `v1/classroom/${params.id}`;
                    break;
                //v1_classroommember_classroomid_var_get
                case 'classroomMemberListDB':
                    url = `v1/classroommember/classroomid/${params.id}`;
                    break;
                case 'classroomMemberViewDB':
                    url = ``;
                    break;
                case 'certificateListDB':
                    url = `v1/certificates/agencyid/${params.id}`;
                    break;
                case 'courseListDB':
                    url = `v1/course`;
                    break;
                case 'courseViewDB':
                    url = `v1/course/${params.id}`;
                    break;
                //case 'myClassroomListDB': 		url = `v1/classroommember/user/${params.userId}`;			break;
                case 'myClassroomListDB':
                    url = `v1/classroommember/user`;
                    break;
                case 'surveyBankListDB':
                    url = `v1/surveybanks`;
                    break;
                case 'surveyBankViewDB':
                    url = `v1/surveybank/${params.id}`;
                    break;
                case 'testBankListDB':
                    url = `v1/testbanks`;
                    break;
                case 'testBankViewDB':
                    url = ``;
                    break;
                case 'lessonBankListDB':
                    url = `v1/lessonbanks`;
                    break;
                case 'lessonBankViewDB':
                    url = ``;
                    break;
                case 'userCertificateListDB':
                    url = `v1/usercertificates/${params.id}`;
                    break;
                case 'userCertificateViewDB':
                    url = `v1/usercertificate/${params.id}`;
                    break;
                // 유저 수업 정보
                case 'userClassInfoViewDB':
                    url = `v1/classroommember/classroomid/${params.classroomid}/user/${params.userId}`;
                    break;
            }
            result = await execute();
            resolve(result);
            async function execute() {
                return new Promise(async (resolve, reject) => {
                    let result = null;
                    // store에 키가 존재하는지 체크	
                    if (Object.keys(store).length === 0) {
                        // 새로운 데이터 가져오기
                        result = newUpdate(setStore, url, params);
                    }
                    else {
                        // 강제 업데이트 체크
                        if (update === undefined || update === false) {
                            // 파라미터 체크
                            if (params.id === undefined) {
                                // 파라미터가 없으면 메모리에서 가져오기
                                result = store;
                            }
                            else {
                                // 파라미터가 존재하는 경우 요청 id를 체크
                                if (params.id === store._id) {
                                    // 요청 id가 같은 경우 메모리에서 가져오기
                                    result = store;
                                }
                                else {
                                    // 요청 id가 같지 않은 경우 새롭게 업데이트
                                    result = newUpdate(setStore, url, params);
                                }
                            }
                        }
                        else {
                            // 강제 업데이트가 아닌경우 메모리에서 가져오기
                            result = newUpdate(setStore, url, params);
                        }
                    }
                    resolve(result);
                });
            }
            async function newUpdate(setData, path, params) {
                return new Promise(async (resolve, reject) => {
                    const res = await wrapAPI('GET', path, params);
                    setData(res.data);
                    resolve(res.data);
                });
            }
        });
    }
    function wrapAPI(method, path, data) {
        return new Promise(async (resolve, reject) => {
            try {
                let modalMessage = null;
                console.log('wrapAPI 1', method);
                const returnData = await requestAPI(method, path, data);
                console.log('wrapAPI end', returnData);
                if (returnData.code === 1000) {
                    return resolve(returnData);
                }
                switch (returnData.code) {
                    case 400:
                        modalMessage = {
                            title: "권한없음",
                            contents: "요청하신 API에 대한 권한이 없어요, 계속 문제가 발생할 경우 관리자에게 문의하세요 (Code: 400)",
                        };
                        //window.location.href = '/logout';
                        // API 권한이 일치하지 않을때
                        break;
                    case 500:
                        // Token 또는 DB Session이 없는 경우
                        //window.location.href = '/logout';
                        break;
                    default:
                        //알수 없는 오류
                        break;
                }
                if (modalMessage !== null) {
                    modal({
                        title: modalMessage.title,
                        contents: modalMessage.contents,
                        buttons: [
                            {
                                label: 'Confirm',
                                color: 'viseCare',
                                fn: async () => {
                                }
                            }
                        ],
                        bgClose: false
                    });
                }
                console.log('wrapAPI resolve');
                resolve(returnData);
            }
            catch (err) {
                console.log('wrapAPI reject');
                modal({
                    title: "서버 오류가 발생했어요",
                    contents: "재접속을 시도해요",
                    buttons: [{
                            label: 'cancel',
                            color: 'gray',
                            fn: () => null
                        },
                        {
                            label: '재접속',
                            color: 'viseCare',
                            fn: async () => {
                                window.location.href = '/signin';
                            }
                        }],
                    bgClose: false
                });
            }
        });
    }
    function actionRecord({ path, type, action, result, title, data, etc }) {
        const res = wrapAPI('POST', `v1/useraction`, {
            path,
            type,
            action,
            result,
            title,
            data,
            etc
        });
    }
    useMemo(() => {
    }, []);
    useEffect(() => { userDBUpdate(); }, [userDB]);
    function basicHome() {
        let url = '/home';
        switch (userDB.userInfo.role) {
            case 'SUPER':
                url = '/users';
                break;
            case 'HQ':
                url = '/users';
                break;
            case 'AGENCY':
                url = '/home';
                break;
            case 'CAREGIVER':
                url = '/userhome';
                break;
        }
        return url;
    }
    //const newValues = {...values, getDB, allowAccessGroup}
    return (_jsx(GlobalDataContext.Provider, { value: values, children: children }));
};
export { GlobalDataContext, GlobalDataProvider };
